import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {Observable, throwError} from "rxjs";
import {catchError, tap, map} from "rxjs/operators";
  
@Injectable({providedIn: 'root'})

export class PlaylistsService {

  constructor(private http: HttpClient){
  }

  fetch():Observable<any[]>{
    return this.http.get<any[]>('/api/playlist')
  }

  getById(id:string):Observable<any>{
    return this.http.get<any>(`/api/playlist/${id}`)
  }



  create(title?:string, image?:File): Observable<any>{
    const formData = new FormData()
    if(image){
      formData.append('image',image, image.name)
    }
    formData.append('title',title || 'Новий плейлист')

    return this.http.post<any>('/api/playlist', formData)
  }
  
  delete(id:string):Observable<any>{
    return this.http.delete<any>(`/api/playlist/${id}`)
  }
 

  updateInfo(id:string, title:string, description:string): Observable<any>{
    const formData = new FormData()
   
    formData.append('title',title)
    formData.append('description',description)

    return this.http.patch<any>(`/api/playlist/${id}`, formData)
  }



  updateCoverImage(id:string,  image:any): Observable<any>{
    const formData = new FormData()
    formData.append('image',image, image.name)

    return this.http.patch<any>(`/api/playlist/${id}`, formData)
  }
 
 
  deleteCoverImage(id:string): Observable<any>{
  
    return this.http.post<any>(`/api/playlist/delete_cover/${id}`, {})
  }

    
 
  updatePublish(id:string, publish:boolean): Observable<any>{
 
    return this.http.patch<any>(`/api/playlist/${id}`, {publish: publish})
  }
  
  updatePrice(id:string, price:number): Observable<any>{
 
    return this.http.patch<any>(`/api/playlist/${id}`, {price: price})
  }

 
  updateSaleMode(id:string, saleMode:boolean): Observable<any>{
 
    return this.http.patch<any>(`/api/playlist/${id}`, {saleMode: saleMode})
  }

   
  updateItems(id:string, itemsArray: string[] , videosCount,  streamsCount): Observable<any>{
 
    return this.http.patch<any>(`/api/playlist/update_items/${id}`, {items: JSON.stringify(itemsArray), videosCount,  streamsCount})
  }

  

}
